import * as Sentry from "@sentry/react";
import { useDiagnosticSessionsDestroyMutation } from "~/store/api";
import { signOutDiagnosticUser } from "~/store/authentication";
import { useAppDispatch } from "~/store/hooks";

interface UseDiagnosticSignOut {
  handleSignOut: () => Promise<void>;
}

export const useDiagnosticSignOut = (): UseDiagnosticSignOut => {
  const dispatch = useAppDispatch();
  const [apiDiagnosticSessionsDestroy] = useDiagnosticSessionsDestroyMutation();

  const handleSignOut = async () => {
    try {
      await apiDiagnosticSessionsDestroy();
    } catch (e: any) {
      Sentry.captureException(e);
    } finally {
      // Always clear client state, even if API call fails
      dispatch(signOutDiagnosticUser());
    }
  };

  return { handleSignOut };
};